import React from 'react'
import Logo from '../../Assets/logo.png'
import Methods from '../../Assets/fizetesilehetosegek.png'
import '../../css/Main/Footer.css'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer-container'>
        <div className='footer-item'>
            <h2>Információ</h2>
            <Link to='/impresszum'><p>Impresszum</p></Link>
            <a href="/files/adatkezelesi.pdf"><p>Adatvédelmi Nyilatkoat</p></a>
            <a href="/files/aszf.pdf"><p>Ászf</p></a>
            <Link to='/fizetes-szallitas'>Fizetés és Szállítás</Link>
            <Link to='/visszakuldes'><p>Visszaküldés</p></Link>
            <Link to='/rolunk'><p>Rólunk</p></Link>
            <Link to='/szolgaltatasok'><p>Szolgáltatások</p></Link>
            <Link to='/kapcsolat'>Kapcsolat</Link>
        </div>
        <div className='footer-item'>
            <h2>Kapcsolat</h2>
            <p>Cégnév: Dentalcoop Plus Kft.</p>
            <p>Email: <a href='mailto:info@dentalcoopplus.hu'>info@dentalcoopplus.hu</a></p>
            <p>Telefon: <a href='tel:+3694318590'>+36 94 318 590</a></p>
            <p>Székhely: 9700 Szombathely, Sárvár utca 12.</p>
            <p>Cím: 9700 Szombathely, Sárvár utca 12.</p>
            <p>Adószám: 13686282-2-18</p>
        </div>
        <div className='footer-payments'>
            <img src={Logo} alt="dentalcoopplus" />
            <img src={Methods} alt="fizetesi_lehetosegek" />
        </div>
        <div className='copyright'>
            <p>Copyright © 2025 Dentalcoop Plus Kft. Minden jog fenntartva.</p>
        </div>
    </div>
  )
}

export default Footer